module.exports = __webpack_public_path__ + "static/media/sitvr_logo.606cf7cc.png";